<template>
  <div class="border bg-white rounded-md px-6 py-4 flex flex-col" :class="{'ring-4 ring-[#559F1B]/20 border-[#559F1B]': zelty}">
    <div class="flex items-center justify-start">
      <img src="/images/integrations/zelty.png" class="h-12">
      <div class="flex gap-2 items-center">
        <span class="text-xl font-bold ml-4">Zelty</span>
        <span class="text-white bg-[#559F1B] pl-2 pr-3 h-6 rounded-full font-bold text-sm flex items-center ml-2" v-if="hubrise"><i class="material-icons text-base mr-1">check</i>Activé</span>
      </div>
    </div>
    <div class="pt-4 flex-1">
      <span class="block leading-7" v-if="!zelty">
        Connectez votre compte Delicity à Zelty, le système de caisse tout-en-un pensé pour la restauration moderne. Recevez automatiquement vos commandes Delicity directement sur votre caisse Zelty, sans double saisie ni perte de temps. Synchronisation fluide, gain de productivité immédiat.
      </span>
      <span class="block leading-7" v-if="zelty">
        Vous êtes connecté à Zelty. Vous pouvez déconnecter votre compte en cliquant sur le bouton ci-dessous.
      </span>
    </div>
    <div class="mt-8 flex flex-wrap gap-4">
      <button class="btn bg-primary text-white" @click="SetupModal.open()" v-if="!zelty">Connexion</button>
      <button class="btn bg-red-600 ring-red-500/40 text-white" @click="disconnectZelty" v-else>Déconnecter</button>
      <a href="https://www.zelty.fr/" target="_blank" class="flex hover:ring-0 items-center btn bg-gray-100 text-gray-600">Site de Zelty</a>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {useModal} from "vue-final-modal";
import ZeltySetupModal from "@/components/Integrations/Modals/ZeltySetupModal.vue";
import {zeltyDisconnect} from "@/services/Integration/ZeltyService";

export default {
  setup(){
    const SetupModal = useModal({component: ZeltySetupModal});
    return {SetupModal}
  },
  methods: {
    async disconnectZelty(){
      await zeltyDisconnect(this.currentMerchant.id);
      await this.$store.dispatch('getMerchantsAction');
    }
  },
  computed: {
    ...mapGetters({
      currentMerchant: 'currentMerchant'
    }),
    zelty(){
      if(!this.currentMerchant.integrations.some(e => e.type === 'zelty')) return false;
      return this.currentMerchant.integrations.find(e => e.type === 'zelty');
    }
  }
}
</script>
